// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__3dDp5","tr":"Table_tr__11f8P","th":"Table_th__2-wWE","td":"Table_td__1mMVQ","selectable":"Table_selectable__3WHyp"};